<template>
  <div class="content">
    <template v-if="activities && activities.length > 0">
      <el-tabs v-model="activityIndex" @tab-click="handleActivityClick" class="activity-tabs">
        <el-tab-pane v-for="(item, idx) in activities" :label="item.name" :name="item.id + ''" :key="idx"></el-tab-pane>
      </el-tabs>
      <el-tabs v-model="activeIndex" @tab-click="handleClick">
        <el-tab-pane label="活动管理" name="1"></el-tab-pane>
        <el-tab-pane label="优惠券使用情况" name="2"></el-tab-pane>
      </el-tabs>

      <!-- 优惠券管理 -->
      <div v-show="activeIndex == '1'">
        <template v-if="activities && activities.length > 0">
          <div class="activity-tips" v-html="handleContent()"></div>
        </template>

        活动开关
        <el-switch v-model="activitySwitch" active-color="#3D9EFC" :active-value="0" :inactive-value="1"
          style="margin: 0 10px" @change="activitySwitchChange"></el-switch>
        <div style="color: #ff4f76; display: inline-block">
          （优惠券拉新活动目前仅支持微信/抖音小程序生效）
        </div>
        <div class="btns">
          <div class="btn theme" @click="set()">添加新优惠券</div>
          <el-button :loading="exportLoading" @click="exportTableColumn">导出数据</el-button>
        </div>
        <!--  表格-->
        <el-table v-loading="loading" :data="tableList.list" border highlight-current-row style="width: 100%"
          header-row-class-name="header">
          <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
          <el-table-column v-for="(item, index) in tableData" :key="index" :prop="item.value" :label="item.text"
            align="center" :width="[
                'useTypeStr',
                'createTime',
                'appCommissionAmount',
              ].includes(item.value)
                ? 170
                : ''
              ">
            <template slot="header" slot-scope="{}">
              {{ item.text }}
              <span v-if="item.value === 'appCommissionAmountStr'">
                <el-tooltip class="item" effect="dark" content="指减去优惠金额后的实际佣金之和" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
            </template>
            <!-- <template slot="header" slot-scope="scope" v-else-if="">
              {{item.text}}
            </template> -->
            <template slot-scope="{ row }">
              <span v-if="item.value === 'activityStatusStr'" class="status"
                :class="row.activityStatus === 1 ? 'green' : ''">{{ row[item.value] }}</span>
              <span v-else>{{ row[item.value] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <span class="btn" @click="set(row)">编辑</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 优惠券使用情况 -->
      <div v-show="activeIndex == '2'">
        <Search :searchForm="searchForm" :searchList="searchList" :optionsStatus="optionsStatus"></Search>
        <!--  表格-->
        <el-table class="table" v-loading="loading" :data="tableList.list" border highlight-current-row
          style="width: 100%" header-row-class-name="header">
          <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
          <el-table-column v-for="(item, index) in tableDataUse" :key="index" :prop="item.value" :label="item.text"
            align="center">
            <template slot-scope="{ row }">
              <span v-if="item.value === 'virtualAddPrice'">
                {{ row[item.value] !== null ? row[item.value] : '-' }}
              </span>
              <span v-else>{{ row[item.value] }}</span>
            </template>

          </el-table-column>
        </el-table>
      </div>

      <!--    分页-->
      <el-pagination v-if="tableList.total > 0" class="pagination" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]"
        :page-size="tableList.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="tableList.total">
      </el-pagination>
    </template>

    <!-- 新增/编辑优惠券 -->
    <el-dialog :title="`${!!id ? '编辑' : '新增'}优惠券`" :visible.sync="dialogVisible" :width="'1220px'" v-if="dialogVisible"
      :before-close="handleClose" :close-on-click-modal="false" @close="closedFun">
      <div class="container" v-loading="boxLoading" element-loading-text="正在加载...">
        <div class="dialog-alert">
          <strong>说明：</strong>
          <p>1、每位用户仅能领取1张此优惠券。</p>
          <p>
            2、使用优惠券购票时与“特惠购票”
            “快速购票”等购票方式的优惠不同享。用户购票价=市场价-优惠券面额。
          </p>
          <p>
            3、使用优惠券购票产生的优惠差额(使用优惠券购票的优惠金额 -
            平台折扣价购票的优惠金额)，将由您自己承担。
          </p>
          <p>
            4、佣金计算：用户使用优惠券购票，平台先按平台折扣价作为用户支付价计算出您的原始佣金，再减去使用优惠券购票产生的优惠差额，得出您最终的佣金。
          </p>
          <p class="dialog-alert_grey">
            例：市场价100元，平台折扣价90元(比市场价优惠10元)，用户使用20元优惠券购票(比市场价优惠20元)，则您的佣金=按平台折扣价90元计算得出的您的原始佣金
            - 优惠差额(20元-10元)。
          </p>
        </div>
        <couponsTemplate ref="couponsTemplateRef" :form="templateFrom" :couponPlatformType="activityType"
          :disabled="!!id" :fullReduction="40"></couponsTemplate>
        <el-form label-width="120px" style="margin-top: 20px; width: 100%" :model="form" :rules="rules" ref="form">
          <el-form-item label="适用对象" prop="objectType">
            <el-radio-group v-model="form.objectType">
              <el-radio :label="1">老客户专用</el-radio>
              <el-radio :label="2">新客户专用</el-radio>
              <el-radio :label="0">新老客户通用</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--        <el-form-item-->
          <!--          label="可用影院"-->
          <!--          prop="cinemaStandardStr"-->
          <!--          class="cinemaStand-item"-->
          <!--          v-if="isCinemaShow"-->
          <!--        >-->
          <!--          <el-tooltip-->
          <!--            class="item"-->
          <!--            effect="dark"-->
          <!--            :content="form.cinemaStandardStr"-->
          <!--            placement="top-start"-->
          <!--            popper-class="tool-tipgz"-->
          <!--          >-->
          <!--            <el-input-->
          <!--              v-model="form.cinemaStandardStr"-->
          <!--              placeholder="请筛选影院"-->
          <!--              disabled-->
          <!--              style="width: 400px"-->
          <!--            ></el-input>-->
          <!--          </el-tooltip>-->
          <!--          <span type="warning" class="cinemaStandBtn" @click="cinemaStandBtn"-->
          <!--            >筛选影院</span-->
          <!--          >-->
          <!--        </el-form-item>-->
          <el-form-item label="优惠券名称" prop="name">
            <el-input v-model="form.name" maxlength="10" placeholder="10个字以内"></el-input>
          </el-form-item>
          <!--        <el-form-item label="基础面额" prop="basePrice">-->
          <!--          <el-input-->
          <!--            v-model="form.basePrice"-->
          <!--            placeholder="请输入"-->
          <!--            style="width: 220px"-->
          <!--          >-->
          <!--            <template slot="append">元</template>-->
          <!--          </el-input>-->
          <!--        </el-form-item>-->
          <!--        <el-form-item label="使用门槛" prop="useType">-->
          <!--          <el-radio-group v-model="form.useType">-->
          <!--            <el-radio :label="0">无门槛</el-radio>-->
          <!--            <el-radio :label="1">单笔订单购票数量＞n可用</el-radio>-->
          <!--          </el-radio-group>-->
          <!--          <el-form-item prop="ticketNum" v-if="form.useType === 1">-->
          <!--            购票数量 ≥-->
          <!--            <el-input-->
          <!--              v-model="form.ticketNum"-->
          <!--              placeholder="请输入"-->
          <!--              style="width: 220px"-->
          <!--            ></el-input>-->
          <!--            使用说明：满{{ form.ticketNum }}张票可用-->
          <!--          </el-form-item>-->
          <!--        </el-form-item>-->
          <el-form-item label="是否可膨胀" prop="isCanExpand" v-if="noCanExpandisShow">
            <el-radio-group v-model="form.isCanExpand">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <template v-if="form.isCanExpand === 1">
              <el-form-item prop="maxExpandPrice">
                最高可膨胀至：
                <el-input v-model="form.maxExpandPrice" placeholder="请输入" style="width: 220px">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="singleExpandPrice">
                膨胀规则设置：分享优惠券给好友，每有1位好友成功领取该优惠券，分享者优惠券面额膨胀
                <el-input v-model="form.singleExpandPrice" placeholder="请输入" style="width: 220px">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </template>
          </el-form-item>

          <el-form-item label="优惠券有效期" prop="expireDate">
            <el-input v-model="form.expireDate" placeholder="请输入" style="width: 220px">
              <template slot="append">天</template>
            </el-input>
            用户领取优惠券后开始计算有效期。
          </el-form-item>
          <el-form-item label="启用状态" prop="status">
            <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-color="#3D9EFC"></el-switch>
            开启状态，本优惠券才可被领取。关闭状态，本券不可再被领取，已领取本券的用户可以正常使用。
          </el-form-item>

          <el-form-item>
            <!-- 操作按钮 -->
            <el-button :loading="submitLoading" type="warning" @click="submit">确认</el-button>
            <el-button type="warning" plain @click="onCancel">取消</el-button>
            <p class="dialog-tips" v-if="!!id">
              优惠券修改仅对未被领取的券生效，已经被领取的券不受影响。
            </p>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!--优惠券功能开关-->
    <div></div>
    <el-dialog :title="`${activitySwitch === 0 ? '关闭' : '开启'}优惠券功能`" :visible.sync="dialogSwitchVisible" width="460px">
      <div class="dialog-content">
        <div class="box">
          <div style="margin-right: 16px">
            确定<span :style="`color:${activitySwitch === 0 ? '#f00' : 'green'}`">{{ activitySwitch === 0 ? "关闭" : "开启"
              }}</span>优惠券活动？
          </div>
          <div v-if="activitySwitch === 0">
            关闭后，小程序将无法领取下方优惠券，已领取的优惠券可继续使用。
          </div>
          <div v-else>
            开启后，用户在小程序可领取下方的优惠券，并可使用优惠券下单。
          </div>
        </div>
      </div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="closeBig">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px" @click="dialogBtnOk">
          确定
        </div>
      </div>
    </el-dialog>
    <!-- 筛选影院 -->
    <!--    <filter-cinema-->
    <!--      v-if="cinemaVisible"-->
    <!--      v-model="cinemaVisible"-->
    <!--      @selectCinema="selectCinema"-->
    <!--      :ids="form.cinemaClassifyId"-->
    <!--      :types="form.cinemaFilterType"-->
    <!--      @close="cinemaVisible = false"-->
    <!--    />-->
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import Search from "@/components/Search";
import mini from "@/api/mini";
const MiniModel = new mini();
import { tableColumn, tableColumnUse } from "./enum";
import { getUserUUID } from "@/utils/auth";
import filterCinema from "./FilterCinema.vue";
import couponsTemplate from '@/components/couponsTemplate.vue'
import { useCouponsTemplate, useSetTemplateFrom } from '@/components/useCouponsTemplate.js'

export default {
  name: "index",
  components: {
    Search,
    Pagination,
    filterCinema,
    couponsTemplate,
  },
  data() {
    return {
      boxLoading: false,
      activityType: '10',
      isCheckLook: false, // 是否查看
      templateFrom: useCouponsTemplate(),
      exportTableColumnParams: {
        appKey: "",
        couponActivityId: "",
      },
      // 活动tab
      activities: [],
      activityIndex: null,
      // 优惠券tab
      activeIndex: "1",
      loading: false,
      // 优惠券管理
      // 优惠券功能
      activitySwitch: 0,
      // 表头
      tableData: tableColumn,
      // 优惠券使用情况
      tableDataUse: tableColumnUse,
      searchForm: {
        appKey: localStorage.getItem("appKeyMini"),
        userTag: "",
        couponName: "",
        orderUUID: "",
        useTime: "",
        useTimeStart: "",
        useTimeEnd: "",
        pageSize: 10,
        pageNo: 1,
        total: "",
        status: "",
        getTime: "",
        getTimeStart: "",
        getTimeEnd: "",
        receiveTime:[
          this.$moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'),
          this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        ],
        createTimeStart: this.$moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'),
        createTimeEnd: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
      },
      searchList: [
        {
          id: "userTag",
          text: "用券用户",
          placeholder: "请输入用券用户",
          type: "input",
        },
        {
          id: "couponName",
          text: "优惠券名称",
          placeholder: "请输入优惠券名称",
          type: "input",
        },
        {
          id: "orderId",
          text: "用券订单号",
          placeholder: "请输入用券订单号",
          type: "input",
        },
        {
          id: "getTime",
          text: "领券时间",
          type: "getTime",
        },
        {
          id: "status",
          text: "优惠券状态",
          placeholder: "请选择优惠券状态",
          type: "select",
        },
        {
          id: "useTime",
          text: "用券时间",
          type: "useTime",
        },
        {
          id: "receiveTime",
          text: "领券日期",
          type: "receiveTime",
        },
      ],
      optionsStatus: [
        {
          label: "全部",
          value: null,
        },
        {
          label: "待使用",
          value: 0,
        },
        {
          label: "已使用",
          value: 1,
        },
      ],
      // 表头
      tableList: [],
      currentPage: 1,

      // 新增优惠券
      id: "", // 当前ID
      dialogVisible: false,
      form: this.initFormData(),
      rules: {
        objectType: [
          {
            required: true,
            message: "请选择适用对象",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "请输入优惠券名称",
            trigger: ["blur", "change"],
          },
        ],
        // basePrice: [
        //   {
        //     required: true,
        //     message: "请输入基础面额",
        //     trigger: ["blur", "change"],
        //   },
        // {
        //     validator: (rule, value, callback) => {
        //       if (!/^\+?[1-9]\d*$/.test(value)) {
        //         callback(new Error("请输入正整数"));
        //       } else if (Number(value) > 40) {
        //         callback(new Error("最大40"));
        //       } else {
        //         callback();
        //       }
        //     },
        //   },
        // ],
        useType: [
          {
            required: true,
            message: "请选择使用门槛",
            trigger: ["blur", "change"],
          },
        ],
        ticketNum: [
          {
            required: true,
            message: "请输入应满足购票数量",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\d+$/.test(value)) {
                callback(new Error("请输入整数"));
              }
              if (Number(value) > 4 || Number(value) < 1) {
                callback(new Error("请输入1-4之间的整数"));
              } else {
                callback();
              }
            },
          },
        ],
        isCanExpand: [
          {
            required: true,
            message: "请选择是否可膨胀",
            trigger: ["blur", "change"],
          },
        ],
        maxExpandPrice: [
          {
            required: true,
            message: "请输入最高可膨胀金额",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^[1-9]\d*(,\d{3})*(\.\d{1,1})?$|^0\.\d{1,1}$/.test(value)) {
                callback(new Error("必须是正数且保留一位小数"));
              } else if (Number(value) < Number(this.templateFrom.couponPrice)) {
                callback(new Error("最高可膨胀金额需超出优惠券基础面额"));
              } else if (Number(value) > Number(this.templateFrom.couponPrice) + 20) {
                callback(new Error("最高可膨胀金额仅能大于基础面额20元"));
              } else {
                callback();
              }
            },
          },
        ],
        singleExpandPrice: [
          {
            required: true,
            message: "请输入每次分享可膨胀金额",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              const val =
                Number(this.form.maxExpandPrice) - Number(this.templateFrom.couponPrice);
              if (!/^[1-9]\d*(,\d{3})*(\.\d{1,1})?$|^0\.\d{1,1}$/.test(value)) {
                callback(new Error("必须是正数且保留一位小数"));
              } else if (Number(value) > val) {
                callback(
                  new Error(`不可超出最高可膨胀金额与基础面额的差值：${val}元`)
                );
              } else {
                callback();
              }
            },
          },
        ],
        expireDate: [
          {
            required: true,
            message: "请输入优惠券有效期",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (
                !/^\d+$/.test(value) ||
                Number(value) < 1 ||
                Number(value > 365)
              ) {
                callback(new Error("请输入1-365之间的整数"));
              } else {
                callback();
              }
            },
          },
        ],
        status: [
          {
            required: true,
            message: "请选择启用状态",
            trigger: ["blur", "change"],
          },
        ],
      },
      dialogSwitchVisible: false,
      submitLoading: false,

      cinemaFilterType: 0, //0:全部影院 1:指定影院分类
      //筛选影院
      cinemaForm: {
        cinemaName: "",
        pageNo: 1,
        pageSize: 10,
      },
      cinemalist: [], //表格数据
      ClassifyList: {}, //影院分类表格
      selectRow: [],
      cinemaLoading: false,
      idsCheckOld: [], //
      idsCheck: [], //勾选id集合
      noCanExpandisShow: true,
      newCheck: [],
      isSubmit: 1,
      cinemaVisible: false, // 筛选影院
      isCinemaShow: true, //是否显示可用影院
      miniAppType: localStorage.getItem("miniAppType"),
      exportLoading: false,
    };
  },
  computed: {
    indexMethodss: function () {
      return (this.ClassifyList.pageNo - 1) * this.ClassifyList.pageSize + 1;
    },
  },
  mounted() {
    if (![0, 5, 3].includes(Number(this.miniAppType))) {
      tableColumnUse.findIndex(item => item.value === 'virtualAddPrice') > -1 && tableColumnUse.splice(tableColumnUse.findIndex(item => item.value === 'virtualAddPrice'), 1)
    }
    this.noCanExpand();
    this.getUserCoupon();
    this.getActivities();
    // this.getClassifyList();
    // this.getCinemaNames();
    // this.getCoupon()
    // this.getList()
  },
  methods: {
    // 除了微信，都禁用 膨胀。只有微信隐藏 影院分类
    noCanExpand() {
      // miniAppType：1淘宝，2天猫，3抖音，4支付宝，5快手，禁用膨胀
      let miniAppTypeArr = ["3", "4", "5"];
      let miniAppType = localStorage.getItem("miniAppType");
      console.log(miniAppType, "miniAppType===");

      // 隐藏影院分类（只针对微信）miniAppType == 0
      if (miniAppType === "undefined" || miniAppType == 0) {
        console.log("隐藏可用影院（只针对微信）");
        // 微信隐藏 影院分类
        this.isCinemaShow = false;
      } else {
        // 除了微信，都禁用 膨胀
        this.noCanExpandisShow = false;
        delete this.rules.isCanExpand;
        delete this.rules.maxExpandPrice;
        delete this.rules.singleExpandPrice;
      }
    },
    async resetCinemaList() {
      this.cinemaForm.cinemaName = "";
      this.cinemaForm.pageNo = 1;
      this.cinemaForm.pageSize = 10;
      await this.getClassifyList();
    },
    // 选中部分,子传父
    selectCinema(arr, type) {
      console.log(arr, type, '点击确定==子传父')
      this.form.cinemaFilterType = type
      this.form.cinemaClassifyId = arr.map((item) => item.id);
      console.log(this.form.cinemaClassifyId, ' this.form.cinemaClassifyId ')
      if (type) {
        this.form.cinemaStandardStr = arr
          .map((item) => item.name)
          .join(",");
      } else {
        this.form.cinemaStandardStr = '全部影院'
      }
      console.log(this.form.cinemaStandardStr, 'this.form.cinemaStandardStr')
    },
    // 筛选影院
    cinemaStandBtn() {
      this.cinemaVisible = true;
    },
    opened() {
      // this.$nextTick(()=> {
      // this.$refs.cinemaTable.toggleRowSelection(this.cinemalist[1]);
      // })
    },
    // // 新增、编辑操作
    async set(row) {
      this.dialogVisible = true;
      this.id = !!row && row.id ? row.id : "";
      console.log(row, 'row==1')
      if (!!row) {
        console.log(row, "当前行数据");
        this.boxLoading = true
        const res = await MiniModel.couponActivityDetail({
          templateId: row.templateId,
          id: row.id,
        })
        this.boxLoading = false
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '获取详情失败')
          return
        }
        let data = res.data.data
        this.templateFrom = useSetTemplateFrom(data.vo)
        this.form = {
          name: data.name,
          status: data.activityStatus,
          objectType: data.objectType,
          isCanExpand: data.isCanExpand,
          maxExpandPrice: data.maxExpandPriceBd,
          singleExpandPrice: data.singleExpandPriceBd,
          expireDate: data.expireDate,
        }
        console.log(this.form, "AAA当前行数据", data);
      } else {
        // setTimeout(() => {
        //   this.$refs.form.resetFields()
        // }, 500)
        this.templateFrom = useCouponsTemplate()
        this.$nextTick(() => {
          this.$refs.couponsTemplateRef.resetForm()
        })
        this.form = this.initFormData();
      }
    },

    handleContent() {
      const item = this.activities.find((i) => i.id == this.activityIndex);
      return item.content || "";
    },
    handleActivityClick(e) {
      this.$nextTick(() => {
        this.activityIndex = e.name;
        this.switchActivity(e.name);
      });
    },
    switchActivity() {
      this.getCoupon();
      this.getList();
    },
    getActivities() {
      MiniModel.getActivities().then((res) => {
        if (res.data.code == 200) {
          this.activities = res.data.data;
          if (res.data.data && res.data.data.length > 0) {
            this.activityIndex = res.data.data[0].id + "";
            this.switchActivity(res.data.data[0].id + "");
            this.switchActivity();
          }
        }
      });
    },
    // 获取优惠券开关
    getUserCoupon() {
      MiniModel.userCoupon({
        appKey: localStorage.getItem("appKeyMini"),
      }).then((res) => {
        if (res.data.code == 200) {
          this.$store.commit("nav/SET_ISOPEN_DOUYIN", res.data.data.isDy);
          if (res.data.data.isOpenCoupon !== 1) {
            this.$router.push("/pc/miniProgram/home");
          }
        }
      });
    },
    getCoupon() {
      MiniModel.getCoupon({
        appKey: localStorage.getItem("appKeyMini"),
        couponActivityId: this.activityIndex,
      }).then((res) => {
        if (res.data.code == 200) {
          this.activitySwitch = res.data.data.activitySwitch;
        }
      });
    },
    dialogBtnOk() {
      MiniModel.switchActivity({
        appKey: localStorage.getItem("appKeyMini"),
        activitySwitch: this.activitySwitch === 1 ? 0 : 1,
        couponActivityId: this.activityIndex,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("设置成功");
          this.activitySwitch = this.activitySwitch === 1 ? 0 : 1;
          this.dialogSwitchVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    activitySwitchChange(value) {
      this.dialogSwitchVisible = true;
      this.activitySwitch = this.activitySwitch === 1 ? 0 : 1;
    },
    handleClick(e) {
      this.$nextTick(() => {
        this.activeIndex = e.name;
        this.getList("reload");
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val;
      this.getList();
    },
    // 重置
    resetCinema() {
      this.resetCinemaList();
    },
    // 重置
    resetCinemaFun() {
      this.form.cinemaClassifyId = [];
      this.idsCheck = [];
      this.form.cinemaStandardStr = "";
      this.cinemaForm.pageNo = 1;
      this.cinemaForm.cinemaName = "";
      this.cinemaForm.pageSize = 10;
      this.form.cinemaFilterType = 0;
      this.cinemaFilterType = 0;
    },
    // 取消
    onCancel() {
      this.id = ''
      console.log("点击取消按钮onCancel=big");
      this.resetCinemaFun();
      // this.$refs.form.resetFields();
      this.dialogVisible = false;
      this.submitLoading = false;
    },
    handleClose() {
      console.log("右上角取消");
      this.resetCinemaFun();
      this.dialogVisible = false;
      this.submitLoading = false;
      // this.onCancel();
    },
    closeBig() {
      console.log("关闭活动swich");
      this.dialogSwitchVisible = false;
      // this.resetCinemaFun();
    },
    // 获取列表
    getList(type) {
      if (type === "reload") {
        this.tableList = [];
        this.currentPage = 1;
        this.searchForm.pageNo = 1;
      } else if (type === "reset") {
        this.tableList = [];
        this.searchForm = {
          appKey: localStorage.getItem("appKeyMini"),
          userTag: "",
          couponName: "",
          orderUUID: "",
          useTime: "",
          useTimeStart: "",
          useTimeEnd: "",
          pageSize: 10,
          pageNo: 1,
          total: "",
        };
      }
      this.loading = true;
      if (this.activeIndex == 1) {
        const params = {
          appKey: this.searchForm.appKey,
          pageSize: this.searchForm.pageSize,
          pageNo: this.searchForm.pageNo,
          couponActivityId: this.activityIndex,
          activityType: this.activityType,
        };
        this.exportTableColumnParams.appKey = params.appKey;
        this.exportTableColumnParams.couponActivityId = params.couponActivityId;
        // 活动列表
        MiniModel.couponActivityPage(params).then((res) => {
          // console.log(res,'searchCoupon')
          if (res.data.code == 200) {
            this.tableList = res.data.data;
            this.tableList.list.forEach((item) => {
              if (item.cinemaClassifyId) {
                let arr = item.cinemaClassifyId.split(",");
                // arr.forEach((item, index) => {
                //   arr[index] = Number(item);
                // });
                item.cinemaClassifyId = arr;
              } else {
                item.cinemaClassifyId = [];
              }
              // console.log(this.tableList.list,'this.tableList.list====')
            });
            this.loading = false;
          } else {
            this.$message.error(res.data.info);
          }
        });
      } else {
        const params = {
          ...this.searchForm,
          couponActivityId: this.activityIndex,
          couponPlatformType: this.activityType,
        };
        MiniModel.couponSearchMarket(params).then((res) => {
          console.log(res,'searchCouponDetail')
          if (res.data.code == 200) {
            this.tableList = res.data.data;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error(res.data.info);
          }
        });
      }
    },
    // 序号
    indexMethod(index) {
      index =
        index + 1 + (this.searchForm.pageNo - 1) * this.searchForm.pageSize;
      return index;
    },
    closedFun() {
      console.log("关闭了大窗口");
    },

    initFormData() {
      return {
        appKey: localStorage.getItem("appKeyMini"),
        name: null,
        basePrice: null,
        useType: 0,
        ticketNum: 0,
        isCanExpand: 1,
        maxExpandPrice: null,
        singleExpandPrice: null,
        expireDate: null,
        status: 0,
        userUUID: getUserUUID(),
        objectType: 0,
        cinemaStandardStr: "全部影院", //可用影院文本
        cinemaFilterType: 0,
        cinemaClassifyId: [],
      };
    },
    async submit() {
      try {
        if (this.submitLoading) {
          return;
        }
        this.$refs.form.validate()
        let data = await this.$refs.couponsTemplateRef.calibration()
        let templateParams = {
          ...data.templateData,
          appKey: localStorage.getItem("appKeyMini"),
          couponPlatformType: this.activityType,
        }
        console.log(templateParams, 'data==couponsTemplateRef')
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            templateParams.name = this.form.name
            let paramsData = {
              activityType: this.activityType,
              appKey: localStorage.getItem("appKeyMini"),
              vo: templateParams,
              name: this.form.name,
              objectType: this.form.objectType,
              isCanExpand: this.noCanExpandisShow ? this.form.isCanExpand : 0,
              maxExpandPrice: this.form.maxExpandPrice ? this.form.maxExpandPrice * 100 : '',
              singleExpandPrice: this.form.singleExpandPrice ? this.form.singleExpandPrice * 100 : '',
              expireDate: this.form.expireDate,
              activityStatus: this.form.status,
              id: this.id ? this.id : '',
            }
            console.log(paramsData, 'paramsDataparamsData')
            this.submitLoading = true;
            console.log(this.form, '一级确认按钮')
            // id转字符串拼接
            // let arr = [];
            // arr = JSON.parse(JSON.stringify(this.idsCheck));
            // let idsStr = arr.splice(",").toString();
            // console.log(idsStr, "idsStr");
            // let params = {
            //   ...this.form,
            //   basePrice: this.handleUnit(this.form.basePrice, 1),
            //   maxExpandPrice: !!this.form.maxExpandPrice
            //     ? this.handleUnit(this.form.maxExpandPrice, 1)
            //     : null,
            //   singleExpandPrice: !!this.form.singleExpandPrice
            //     ? this.handleUnit(this.form.singleExpandPrice, 1)
            //     : null,
            //   couponActivityId: this.activityIndex,
            //   // cinemaFilterType: this.cinemaFilterType,
            //   // cinemaClassifyId: idsStr,
            // };
            // if(params.cinemaFilterType) {
            //   // params.cinemaStandardld = params.cinemaClassifyId.join(',')
            //   params.cinemaClassifyId = params.cinemaClassifyId.join(',')
            //   // delete params.cinemaClassifyId
            // }
            // console.log(params.cinemaStandardld,'params.cinemaStandardld')
            // if (!this.noCanExpandisShow) {
            //   params.isCanExpand = 0;
            // }
            // if (!this.isCinemaShow) {
            //   console.log("隐藏了可用影院==确认按钮");
            // }
            if (this.id) {
              // params = {
              //   ...params,
              //   id: this.id,
              // };
              // console.log(params, "保存编辑数据params===");
              // return
              MiniModel.couponActivityEdit(paramsData).then((res) => {
                if (res.data.code == 200) {
                  this.$message.success("修改成功");
                  this.onCancel();
                  this.getList();
                } else {
                  this.$message.error(res.data.message || '编辑优惠券报错');
                }
                setTimeout(() => {
                  this.submitLoading = false;
                }, 1000);
              });
            } else {
              // params = {
              //   ...params,
              //   isCanExpand: 0,
              //   cinemaFilterType: 0,
              //   cinemaStandardld: "",
              // };
              console.log(paramsData, "新增数据params===");
              // return
              MiniModel.couponActivitySave(paramsData).then((res) => {
                if (res.data.code == 200) {
                  this.$message.success("添加成功");
                  this.onCancel();
                  this.getList();
                } else {
                  this.$message.error(res.data.message || '创建优惠券报错');
                }
                setTimeout(() => {
                  this.submitLoading = false;
                }, 1000);
              });
            }
          } else {
            this.submitLoading = false;
          }
        });
      } catch (err) {
        console.log(err, '提交按钮报错111')
      }
    },
    handleUnit(value, type) {
      return type === 1 ? Number(value) * 100 : Number(value) / 100;
    },
    // 导出
    exportButton() {
      this.exportLoading = true
      const params = {
        ...this.searchForm,
        couponActivityId: this.activityIndex,
        couponPlatformType: this.activityType,
      };
      MiniModel.couponExportV3Market(params).then(async(res) => {
        const code = res.data.code
        const message = res.data.message
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
              this.exportLoading = false
            }
          });
        } else {
          this.$Message.error(message)
        }
      });
    },
    // 导出活动管理表格
    exportTableColumn() {
      this.exportLoading = true
      MiniModel.exportCouponActivity({
        appKey: this.exportTableColumnParams.appKey,
        activityType: 10
      }).then((res) => {
        this.exportLoading = false
        console.log(res, "导出活动管理表格");
        if (res.status == 200) {
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          console.log("blob", blob);
          let url = window.URL.createObjectURL(blob);
          console.log("url", url);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = window.URL.createObjectURL(blob);
          a.download = "活动管理导出_" + this.formatDate(new Date()) + ".xls";
          a.click();
          window.URL.revokeObjectURL(url);
        } else {
          this.exportLoading = false
          this.$Message.error(res.info || res.message)
          // this.$Message.error(res.info || res.message)
        }
      });
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + m + d;
    },
    //正则验证
    handleOnInput(value) {
      let str = value;
      let len1 = str.substr(0, 1);
      let len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      if (len1 == "+") {
        str = "";
      }
      if (len1 == "-") {
        str = "";
      }

      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        let str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换
      return str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
    },
  },
};
</script>

<style scoped lang="less">
//弹出层的高度
/deep/.el-dialog.import-dialog {
  max-height: 830px !important;
  // max-height: 800px;
  overflow-y: auto;
  // margin: auto !important;
}

//弹出层里内容的高度
// /deep/.el-dialog__body{
//   max-height: 70vh!important;
// }
/deep/.el-table .DisableSelection .cell .el-checkbox__inner {
  display: none;
}

.pagess {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px !important;
}

.cinemaStandBtn {
  margin-left: 20px;
  cursor: pointer;
  color: #ff8622;
  text-decoration: underline;
}

.cinemaContent-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .cinemaContent-top-r {
    display: flex;

    .cinemaContent-top-search {
      display: flex;
      margin-right: 20px;
      align-items: center;

      .cinemaContent-top-search-text {
        margin-right: 10px;
      }
    }
  }
}

.cinemaContent-botm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .cinemaContent-botm-text {
    margin-left: -20px;
    color: #999999;
    font-size: 14px;
    margin-right: 25px;
  }

  .cinemaContent-top-r {
    display: flex;

    .cinemaContent-top-search {
      display: flex;
      margin-right: 20px;
      align-items: center;

      .cinemaContent-top-search-text {
        margin-right: 10px;
      }
    }
  }
}

.cinemaContent-botm-text {
  margin-left: -20px;
  color: #999999;
  font-size: 14px;
  margin-right: 25px;
}

.content {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;

  .title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 25px;
  }

  /deep/.search .search-form {
    align-items: initial !important;
  }
}

.table {
  margin-top: 30px;
}

.detail {
  display: flex;
  align-items: center;

  .detail-item {
    display: flex;
    margin-top: 20px;

    .item-text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 20px;
      width: 70px;
      text-align: right;
      margin-right: 10px;
    }

    .item-span {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 20px;
    }
  }
}

.dialog {
  padding: 20px 80px;

  .dialog-title {
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }

  .dialog-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
  }

  .textarea {
    width: 100%;
    height: 82px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #eeeeee;
    margin-top: 10px;
  }

  .dialog-button {
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;

    .button-success {
      width: 76px;
      height: 32px;
      background: #ff8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }

    .button-cancel {
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.btn {
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ff8622;
  line-height: 18px;
  cursor: pointer;

  &.theme {
    width: 120px;
    height: 32px;
    background: #3d9efc;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    margin-right: 10px;
    cursor: pointer;
  }
}

.delete {
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ff4f76;
  line-height: 18px;
  cursor: pointer;
}

.header {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  margin-right: 4px;
}

.overText {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  cursor: pointer;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #eeeeee;
}

/deep/.el-tabs__item.is-active {
  color: #ff8622 !important;
}

/deep/.el-tabs__active-bar {
  background-color: #ff8622 !important;
}

/deep/.el-tabs__item:hover {
  color: #ff8622 !important;
}

/deep/.el-table th,
.el-table tr {
  background-color: #fcfaf8;
}

/deep/.el-tabs__nav-wrap::after {
  height: 1px !important;
}

.dialog-alert {
  display: block;
  padding: 10px;
  color: #666;
  background: #efefef;

  strong {
    display: block;
    color: #333;
  }

  p {
    display: block;
  }

  &_grey {
    color: #999;
  }
}

.status {
  display: block;
  position: relative;

  &::before {
    content: "";
    float: left;
    width: 6px;
    height: 6px;
    background: #ff8622;
    border-radius: 50%;
    margin-top: 8px;
  }

  &.green::before {
    background: #51c456;
  }
}

/deep/.el-radio__input.is-checked+.el-radio__label {
  color: #333 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #ff8622 !important;
  border-color: #ff8622 !important;
}

/deep/.el-form-item .el-form-item {
  margin-bottom: 12px;
}

.dialogFooter {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;

  div {
    width: 100px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .dialogFooter-ok {
    background-color: #ff8622;
    color: #ffffff;
  }
}

.activity-tips {
  display: block;
  padding: 10px 20px;
  // border:1px solid #ccc;
  margin-bottom: 10px;
  background: #f5f5f7;
  font-size: 12px;

  strong {
    color: #333;
    display: block;
    font-size: 16px;
    padding: 5px 0;
  }

  p {
    color: #666;
    display: block;
    padding: 5px 0;
  }
}

.dialog-tips {
  color: rgb(255, 79, 118);
  display: inline-block;
  padding-left: 20px;
}

.activity-tabs {

  /deep/.el-tabs__nav-wrap::after,
  .el-dialog__wrapper .el-tabs__nav-wrap::after {
    background: none !important;
  }

  /deep/.el-tabs__active-bar {
    display: none;
  }

  /deep/.el-tabs__item.is-active {
    color: #333 !important;
    font-size: 16px;
    font-weight: bold;
  }

  /deep/.el-tabs__item {
    height: auto !important;
  }

  /deep/.el-tabs__header {
    margin: 0 !important;
  }
}

.btns {
  display: flex;
  padding: 20px 0;
}

// /deep/ .el-input__suffix {
//   margin-bottom: 40px !important;
// }
// /deep/ .el-input__clear{
//   color: red;
// }
// /deep/.el-input__wrapper {
//   position: relative;
//   .el-input__inner {
//     padding-right: 18px;
//   }

// }
/deep/.el-input__suffix {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-60%);
  color: red;
}
</style>
<style>
.tool-tipgz {
  max-width: 600px;
}

.el-tooltip__popper {
  max-width: 60% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponNew/index.vue